"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-CapturePreview',
    border: 'c-CapturePreview--border',
    wrapper: 'c-CapturePreviewWrapper',
    image: 'c-CapturePreview__Image',
    overlay: 'c-CapturePreview__Overlay',
    selectable: 'c-CapturePreview__Image--selectable',
    selected: 'c-CapturePreview__Image--selected',
    crosshair: 'c-CapturePreview__Crosshair',
    truesize: 'c-CapturePreview__truesize',
    photomeasure: 'c-CapturePreview__photomeasure',
    date: 'c-CapturePreview__date',
    hiddenCapture: 'c-CapturePreview__hiddenCapture'
};
exports.Style = {
    [exports.CSS.container]: {
        position: 'relative',
        width: '100%',
        height: '100%'
    },
    [exports.CSS.wrapper]: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        height: `100%`
    },
    [exports.CSS.border]: {
        border: `${theme_1.DefaultTheme.space(1)} solid transparent`
    },
    [exports.CSS.crosshair]: {
        position: 'absolute',
        display: 'block',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        'background-image': (0, theme_1.assetURL)('/images/p2p-dot.png'),
        'background-position': '50%',
        'background-repeat': 'no-repeat',
        'background-size': '40%',
        'pointer-events': 'none'
    },
    [exports.CSS.overlay]: {
        position: 'absolute',
        width: 'inherit',
        height: 'inherit'
    },
    [exports.CSS.image]: {
        height: '100%'
    },
    [exports.CSS.selectable]: {
        cursor: 'pointer'
    },
    [exports.CSS.selected]: {
        cursor: 'default',
        border: `${theme_1.DefaultTheme.space(1)} solid ${theme_1.DefaultTheme.color.accent}`
    },
    [exports.CSS.truesize]: {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: '24px',
        height: '24px',
        'border-radius': '50%',
        'background-color': theme_1.DefaultTheme.background.offWhite,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        'background-image': (0, theme_1.assetURL)('/images/ike_logo_no-text.svg'),
        'background-size': '100%',
        'background-repeat': 'no-repeat'
    },
    [exports.CSS.truesize + ' svg']: {
        width: '24px',
        height: '24px'
    },
    [exports.CSS.photomeasure]: {
        position: 'absolute',
        right: `-${theme_1.DefaultTheme.space(2)}`,
        bottom: `-${theme_1.DefaultTheme.space(2)}`,
        'background-image': (0, theme_1.assetURL)('/images/ike_logo_no-text.svg'),
        'background-repeat': 'no-repeat',
        'background-position': '50%',
        'background-size': 'cover',
        'border-radius': '50%',
        'background-color': theme_1.DefaultTheme.background.offWhite,
        border: `1px solid ${theme_1.DefaultTheme.background.offWhite}`,
        width: theme_1.DefaultTheme.space(5),
        height: theme_1.DefaultTheme.space(5)
    },
    [exports.CSS.date]: {
        position: 'absolute',
        left: theme_1.DefaultTheme.space(0.5),
        bottom: theme_1.DefaultTheme.space(0.5),
        'background-color': 'rgba(224, 224, 224, 0.75)',
        'font-size': '10px',
        color: theme_1.DefaultTheme.font.color.primary,
        'line-height': 'normal'
    },
    [exports.CSS.hiddenCapture + '>:not(i)']: {
        filter: 'grayscale(100%) brightness(40%)'
    }
};
//# sourceMappingURL=capture.preview.style.js.map